export { default } from "./QuickAddToCloset";
